import def from "ajv/dist/vocabularies/discriminator";
import {Pagination} from "react-bootstrap";

const TablePagination = ({page, setPage, count}) => {
  return (
    <Pagination>
      <Pagination.Prev
        disabled={page + 1 === 1}
        onClick={() => setPage((prev) => prev - 1)}
      />
      {page - 1 > 0 &&
        (count > 3 ? (
          <Pagination.Ellipsis disabled />
        ) : (
          <Pagination.Item onClick={() => setPage(0)}>1</Pagination.Item>
        ))}
      {page > 0 && (
        <Pagination.Item onClick={() => setPage((prev) => prev - 1)}>
          {page}
        </Pagination.Item>
      )}
      <Pagination.Item active>{page + 1}</Pagination.Item>
      {page + 1 < count && (
        <Pagination.Item onClick={() => setPage((prev) => prev + 1)}>
          {page + 2}
        </Pagination.Item>
      )}
      {page + 2 < count && <Pagination.Ellipsis disabled />}

      <Pagination.Next
        disabled={page + 1 === count}
        onClick={() => setPage((prev) => prev + 1)}
      />
    </Pagination>
  );
};

export default TablePagination;
